export const COMPLAINT_REPORT_ROUTE = "/complaint-report";
export const COMPLAINT_REPORT_GET_MECHANIC_DATA_ROUTE = "/complaint-report/mechanic-complaint-data";
export const COMPLAINT_REPORT_GET_CITY_DATA_ROUTE = "/complaint-report/city-complaint-data";
export const COMPLAINT_REPORT_ASSIGN_ROUTE = "/crl-assign";